<script setup lang="ts">
  import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import { ref, onMounted } from 'vue'
  import { useRouter } from 'vue-router'

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const router = useRouter()

  onMounted(() => {
    modal.value = new Modal('#modal-mobile-warning', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function toHomePage() {
    router.push('/')
    hide()
  }

  defineExpose({ show, hide })
</script>

<template>
  <div
    id="modal-mobile-warning"
    class="modal modal-sm fade"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content px-3 pb-4">
        <div class="modal-body">
          <img alt="modo de isolamento" src="../assets/isolation-mode.svg" />
        </div>

        <div>
          <p class="fs-6 px-2">
            <strong>Ops!</strong> Notamos que você está acessando esta página
            pelo smartphone.
          </p>
        </div>

        <div>
          <p class="fs-6 px-2">
            Lembre-se de que
            <strong
              >o seu Certificado Digital só pode ser instalado em um
              computador.</strong
            >
          </p>
        </div>

        <div class="mt-2">
          <button class="btn btn-primary w-100" @click="toHomePage">
            <icon-component name="house" class="me-2" />
            Página Inicial
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .modal-content {
    border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
    border-radius: var(--bs-modal-border-radius);
  }
</style>
